import { render, staticRenderFns } from "./BusinessAdd.vue?vue&type=template&id=5646359c&scoped=true"
import script from "./BusinessAdd.vue?vue&type=script&lang=ts"
export * from "./BusinessAdd.vue?vue&type=script&lang=ts"
import style0 from "./BusinessAdd.vue?vue&type=style&index=0&id=5646359c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5646359c",
  null
  
)

export default component.exports